// Translated from en/wlps.js to Spanish
export default {};
